import React, {useState} from 'react';
import { createGlobalStyle } from 'styled-components';
import { promoteToAdmin } from '../data'

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    
  }
  .box-login p{
    color: #a2a2a2 !important;
  }
  .box-login{
    border-radius: 3px;
    padding: 40px 50px;
  }
`;

const PromotToAdminForm= () => {
  const [walletAddress, setWalletAddress] = useState('');

  const handleAddressInputChanged = (event) =>{
    setWalletAddress(event.target.value);
  }

  const handlePromotToAdminButtonAction = async() => {
    if(walletAddress===""){
      alert("Wallet Address or Amount can't be empty");
    }else{
      await promoteToAdmin(walletAddress);
    }
  }

  return(
<div>
<GlobalStyles/>
      <div className='container'>
        <div className='row align-items-center px-0'>
          <div className="col-lg-10 offset-lg-10 m-auto px-0">
            <div className="box-login">
              <h3 className="mb10">Promote To Admin</h3>
              <div  name="setBeneficiaryForm" id='setBeneficiaryForm' className="form-border">

                  <div className="field-set">
                      <input type='text' name='walletAddress' id='walletAddress'  onChange={handleAddressInputChanged.bind(this)} className="form-control" placeholder="Address of person to make admin"/>
                  </div>
                
                <div className="field-set">
                  <input type='submit' id='sendBtn' onClick={async()=> await handlePromotToAdminButtonAction()} value='Set Beneficiary' className="btn btn-main btn-fullwidth color-2"/>
                </div>
                
                <div className="clearfix"></div>  
                <div className="spacer-half"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
</div>
  )

}
export default PromotToAdminForm;